export default __webpack_public_path__ + "static/image2-c2d99dbea1833461c99241d0f5164a23.jpg";